import { tenantRepo } from "@/repositories/tenantRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetTenant = (tenantId: string) => {
  return useObservable(() => tenantRepo.get(tenantId), [tenantId]);
};

export const useGetTenantByFriendly = (friendlyId: string) => {
  return useObservable(
    () => tenantRepo.getByFriendly(friendlyId),
    [friendlyId]
  );
};

export const useTenantList = () => {
  return useObservable(() => tenantRepo.list(), []);
};
